import type { ApiFiltersResult } from "@modules/types.ts"

export function updateAdvertCardContainerUI(advertCount: number) {
    if (advertCount === 0) {
        for (const element of document.getElementsByClassName("pagination-container")) {
            element.classList.add("hide")
        }
        for (const element of document.getElementsByClassName("anzeigenmarkt-display-options")) {
            element.classList.add("hide")
        }
    } else {
        for (const element of document.getElementsByClassName("pagination-container")) {
            element.classList.remove("hide")
        }
        for (const element of document.getElementsByClassName("anzeigenmarkt-display-options")) {
            element.classList.remove("hide")
        }
    }
}

export function updateAdvertResultsFoundInfoInDom(apiResult: ApiFiltersResult | undefined) {
    const resultsInfoFoundElement = document.querySelector("#advert-results-found-info")
    if (resultsInfoFoundElement) {
        resultsInfoFoundElement.innerHTML = apiResult?.advertResultsFoundInfo || ""
    }
}

updateAdvertCardContainerUI(SearchConfig.advertCount)
